export default __webpack_public_path__ + "static/media/sch8_w1024.03bbdb8e.jpg";